import { useInfiniteQuery } from 'react-query'
import { getBankCards } from 'services/bankManagements'

export default function useGetBankAccounts() {
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['bank-account-managements-bankAccounts'],
        ({ pageParam = 1, queryKey }) => getBankCards(pageParam),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('cursor')
                    : undefined
            },
        }
    )
    return { data, isLoading, fetchNextPage, refetch }
}
